import styled from 'styled-components';

export const GoalStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  .goalsContainer {

   &__titleWrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &__tooltip {
      width: 250px;
    }

    &__inputsWrapper {
      display: flex;
      align-items: flex-end;
      flex-direction: row;
      gap: var(--spacing-16);

      > * {
        flex: 1;
        min-width: 0;
      }

      .singleSelectWrapper {
        min-width: 0;
      }
    }
    &__warningInput {
      border: 0.67px solid #DE7834;
    }

    &__alertMessage {
      padding-top: 8px;
      color: #D6712D;
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
